import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "../utils/i18n";

const SPONSORS = [
  {
    src: "/images/partners/logopaab.svg",
    alt: "PAAB",
    link: "https://www.paab.com/",
    maxWidth: { xs: 88, sm: 110, md: 140, lg: 140 },
    maxHeight: { xs: 36, sm: 44, md: 52, lg: 36 },
  },
  {
    src: "/images/partners/Autec_logo.svg",
    alt: "Autec",
    link: "https://www.autecsafety.com/",
    maxWidth: { xs: 88, sm: 110, md: 140, lg: 170 },
    maxHeight: { xs: 36, sm: 44, md: 52, lg: 60 },
  },
  {
    src: "/images/partners/jonsson_transparent_vector.svg",
    alt: "Jonsson",
    link: "https://www.pjjonsson.se/sv",
    maxWidth: { xs: 88, sm: 110, md: 140, lg: 170 },
    maxHeight: { xs: 36, sm: 44, md: 52, lg: 60 },
  },
  {
    src: "/images/partners/LKAB_logo.svg",
    alt: "LKAB",
    link: "https://lkab.com/",
    maxWidth: { xs: 88, sm: 110, md: 140, lg: 170 },
    maxHeight: { xs: 36, sm: 44, md: 52, lg: 35 },
  },
  {
    src: "/images/partners/Swarco_logo.svg",
    alt: "Swarco",
    link: "https://www.swarco.com",
    maxWidth: { xs: 88, sm: 110, md: 140, lg: 170 },
    maxHeight: { xs: 36, sm: 44, md: 52, lg: 60 },
  },
  {
    src: "/images/partners/ELCENTRALEN_highres.svg",
    alt: "ELCENTRALEN",
    link: "https://www.el-centralen.com/",
    maxWidth: { xs: 88, sm: 110, md: 140, lg: 170 },
    maxHeight: { xs: 36, sm: 44, md: 52, lg: 60 },
  },
  {
    src: "/images/partners/drimote-logo.svg",
    alt: "Drimote",
    link: "https://www.drimote.com",
    maxWidth: { xs: 88, sm: 110, md: 140, lg: 170 },
    maxHeight: { xs: 36, sm: 44, md: 52, lg: 90 },
  },
  {
    src: "/images/partners/oem-logo.svg",
    alt: "OEM",
    link: "https://www.oemautomatic.se/",
    maxWidth: { xs: 88, sm: 110, md: 140, lg: 170 },
    maxHeight: { xs: 36, sm: 44, md: 52, lg: 100 },
  },
  {
    src: "/images/partners/hydtec_logo_croppad.svg",
    alt: "HydTec",
    link: "https://hydtec.se/",
    maxWidth: { xs: 88, sm: 110, md: 140, lg: 170 },
    maxHeight: { xs: 36, sm: 44, md: 52, lg: 30 },
  },
  {
    src: "/images/partners/Vindo_marin_logo.svg",
    alt: "Vindo Marin",
    link: "https://vindomarin.se/",
    maxWidth: { xs: 88, sm: 110, md: 140, lg: 170 },
    maxHeight: { xs: 36, sm: 44, md: 52, lg: 50 },
  },
  {
    src: "/images/partners/granitor.svg",
    alt: "Granitor",
    link: "https://www.granitor.se/",
    maxWidth: { xs: 88, sm: 110, md: 140, lg: 170 },
    maxHeight: { xs: 36, sm: 44, md: 52, lg: 80 },
  },
];

export default function Sponsors() {
  const [isPaused, setIsPaused] = React.useState(false);
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        height: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        background: "#fff",
        width: { xs: "100%", md: "65%" },
        my: 10,
      }}
    >
      <Box sx={{ width: "100%", mx: "auto" }}>
        <Typography
          variant="overline"
          align="center"
          sx={{ color: "#475467", mb: 4, fontWeight: 500 }}
        >
          {t("sponsors.label")}
        </Typography>

        <Box
          sx={{
            overflow: "hidden",
            position: "relative",
            width: "100%",
            px: 0,
            WebkitMaskImage:
              "linear-gradient(to right, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 10%, rgba(0,0,0,1) 90%, rgba(0,0,0,0) 100%)",
            maskImage:
              "linear-gradient(to right, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 10%, rgba(0,0,0,1) 90%, rgba(0,0,0,0) 100%)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 6,
              alignItems: "center",
              width: "max-content",
              animation: "marquee 30s linear infinite",
              animationPlayState: isPaused ? "paused" : "running",
            }}
          >
            {[...SPONSORS, ...SPONSORS].map((sponsor, i) => (
              <Box
                key={`${sponsor.alt}-${i}`}
                component="a"
                href={sponsor.link}
                target="_blank"
                rel="noreferrer"
                onMouseEnter={() => setIsPaused(true)}
                onMouseLeave={() => setIsPaused(false)}
                sx={{
                  flex: "0 0 auto",
                  textAlign: "center",
                  mx: 2,
                  mt: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: { xs: 96, sm: 120, md: 140 },
                  cursor: "pointer",
                  textDecoration: "none",
                  transition: "transform 180ms ease, filter 180ms ease",
                  filter: "brightness(1)",
                  "&:hover": {
                    transform: "scale(1.08)",
                    filter: "brightness(1.22)",
                  },
                }}
              >
                <Box
                  component="img"
                  src={sponsor.src}
                  alt={sponsor.alt}
                  sx={{
                    display: "block",
                    maxWidth: sponsor.maxWidth,
                    maxHeight: sponsor.maxHeight,
                    width: "auto",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>

      <style>{`@keyframes marquee {0% { transform: translateX(-50%); } 100% { transform: translateX(0%); } }`}</style>
    </Box>
  );
}
